import {Enum} from 'enumify';

class AdHocViewEnum extends Enum{}

AdHocViewEnum.initEnum({
            ACCOUNT: 'accountView',
            PACKAGE: 'packageView',
            SHIPMENT: 'shipmentView',
            SHIPMENTBYSTATUS: 'shipmentByStatusView',
            COUPON: 'couponView',
            REFERRAL: 'referralView',
            MANUALACCOUNTBALANCE: 'manualAccountBalance'
        }
     );

export default AdHocViewEnum;
